import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import ContextWrapper from 'components/templates/Wrappers/Sidebars/ContextWrapper/ContextWrapper';

const StyledDatabaseEntityProfileWrapper = styled(ContextWrapper)`
  ${ComponentStyles}
`;

StyledDatabaseEntityProfileWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledDatabaseEntityProfileWrapper;
